import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import React, {useState} from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {Toaster} from 'react-hot-toast';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom'; 
import {PersistGate} from 'redux-persist/integration/react';

import App from './App';
import {FilterProvider} from './context/FilterContext/FilterContext';
import store, {persistor} from './redux/store/configureStore';
import reportWebVitals from './reportWebVitals';
import 'aos/dist/aos.css';
   
const queryClinet = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <QueryClientProvider client={queryClinet}>
          <BrowserRouter> 
            <FilterProvider>
              <Toaster position={'top-center'} reverseOrder={false} />
              <App />
            </FilterProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

document.addEventListener('input', e => {
  if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
    if (e.target.value.startsWith(' ')) {
      e.target.value = e.target.value.trimStart();
    }
  }
});
